import { render, staticRenderFns } from "./product-price-table-empty.vue?vue&type=template&id=2b2e4b91&"
import script from "./product-price-table-empty.vue?vue&type=script&lang=ts&"
export * from "./product-price-table-empty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports